/**
 * Lightweight hook that returns the total count of SUPPRESSED issues.
 * Fetches a single-item page just for the total_count metadata.
 */

import { useQuery } from "@tanstack/react-query";
import { listSecurityIssues } from "@/services/securityIssuesService";
import { useApiReady } from "@/hooks/useApi";

export function useSuppressedCount() {
  const isApiReady = useApiReady();

  return useQuery({
    queryKey: ["security-issues", "suppressed-count"],
    queryFn: () =>
      listSecurityIssues({
        status: "SUPPRESSED",
        items_per_page: 1,
        page: 1,
      }),
    staleTime: 60000,
    enabled: isApiReady,
    select: (data) => data.total_count,
  });
}
